<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-shuffle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.02 27.96a1 1 0 01.59.192l6.276 4.584a1 1 0 01-.005 1.62l-6.277 4.519a1 1 0 01-1.585-.812v-2.507c-3.884-.036-6.253-1.167-8.377-3.801a33.314 33.314 0 002.241-3.776c1.689 2.635 3.229 3.549 6.136 3.576V28.96a1 1 0 011-1zm-.01-20.016a1 1 0 01.584.188l6.284 4.514a1 1 0 01.007 1.62L35.6 18.861a1 1 0 01-1.59-.808v-2.592c-4.059.037-5.568 1.773-8.221 7.564-.298.653-.457 1-.605 1.32-3.56 7.695-7.202 11.091-15.166 11.214H6v-4.02h3.988c6.054-.093 8.567-2.437 11.55-8.882.144-.312.298-.65.598-1.306 3.241-7.074 5.76-9.853 11.875-9.91V8.944a1 1 0 011-1zm-24.99 3.497c4.802.074 8.033 1.338 10.622 4.018a45.954 45.954 0 00-1.989 3.85c-2.095-2.693-4.57-3.785-8.664-3.849H6v-4.02h4.019z"/></svg>
</template>
<script>

export default {
  name: 'IconShuffle',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
